import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { getProcedure } from "../../api/procedure";
import { getProcedureRole } from "../../api/procedure/getProcedureRole";
import { getStage } from "../../api/stage";
import { getComplaint } from "../../api/stage/complaints";
import Complaints from "../../components/Stages/Complaints/Complaints";
import { useTranslationHook } from "../../hooks";
import { setLoading } from "../../store/UI";
import { Procedure, ProcedureRole } from "../../types/model/procedure";
import { Complaint, Stage } from "../../types/model/stage";

const StageComplaints = (props: any) => {
  const { t } = useTranslationHook();
  const dispatch = useDispatch();

  const { accountId, projectId, activityId, procedureId, stageId } =
    useParams<{
      accountId: string;
      projectId: string;
      activityId: string;
      procedureId: string;
      stageId: string;
    }>();

  const [stage, setStage] = useState<Stage>();
  const [complaint, setComplaint] = useState<Complaint>();
  const [procedure, setProcedure] = useState<Procedure>();
  const [procedureRole, setProcedureRole] = useState<ProcedureRole>();
  const [loadingLocal, setLoadingLocal] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!projectId || !activityId || !procedureId || !stageId) return;

      dispatch(setLoading(true));

      try {
        const [
          stageRes,
          complaintRes,
          procedureRes,
          procedureRoleRes,
        ] = await Promise.all([
          getStage(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getComplaint(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getProcedure(Number(projectId), Number(activityId), Number(procedureId)),
          getProcedureRole(Number(projectId), Number(activityId), Number(procedureId)),
        ]);

        setStage(stageRes);
        setComplaint(complaintRes);
        setProcedure(procedureRes);
        setProcedureRole(procedureRoleRes);

        enqueueSnackbar(t("stages.complaints.complaints-loaded"), {
          variant: "success",
        });
      } catch (error) {
        console.error(error);
        enqueueSnackbar(t("stages.complaints.error-loading"), {
          variant: "error",
        });
      } finally {
        dispatch(setLoading(false));
        setLoadingLocal(false);
      }
    };

    fetchData();
  }, [projectId, activityId, procedureId, stageId, dispatch]);

  if (loadingLocal || !stage || !procedure || !procedureRole) return null;

  return (
    <Complaints
      stage={stage}
      complaint={complaint}
      procedureRole={procedureRole}
      procedure={procedure}
      accountId={Number(accountId)}
      projectId={Number(projectId)}
      procedureId={Number(procedureId)}
      activityId={Number(activityId)}
    />
  );
};

export default StageComplaints;